import { createContext, type FC, type ReactNode, useContext } from 'react'
import { type SearchPageStore } from '../store/searchPageStore'

export const SearchPageContext = createContext<SearchPageStore | null>(null)

export const useSearchPageContext = () => {
  const context = useContext(SearchPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SearchPageContext')

  return context
}

type IProviderSearchPageProps = {
  value: SearchPageStore
  children: ReactNode
}

export const ProviderPageUsers: FC<IProviderSearchPageProps> = ({ value, children }) => {
  return <SearchPageContext.Provider value={value}>{children}</SearchPageContext.Provider>
}
